/*
 *		Copyright (c) 2011-2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .directive('accSelectLanguage', ['Settings', '$translate', function (Settings, $translate) {
        return {
            scope: {
                setLanguage: '=',
                defaultLanguage: '<'
            },
            replace: true,
            template: '<div class="btn-group">\
                    <a class="btn btn-link dropdown-toggle" data-toggle="dropdown">\
                        <strong>{{getCurrentLanguage().value}}</strong>\
                        <span class="caret"></span>\
                    </a>\
                    <ul class="dropdown-menu">\
                        <li ng-repeat="language in languages | orderBy:\'id\'">\
                            <a ng-click="setCurrentLanguage(language)" href>{{language.value}}</a>\
                        </li>\
                    </ul>\
                </div>',
            link: function ($scope) {
                var currentLanguage = $scope.defaultLanguage || $translate.use();

                $scope.languages = Settings['supported_locales'];

                $scope.getCurrentLanguage = function () {
                    return currentLanguage;
                };

                $scope.setCurrentLanguage = function (lang) {
                    currentLanguage = lang;
                    $scope.setLanguage(lang);
                };

                angular.forEach($scope.languages, function (lang) {
                    if (lang.id === currentLanguage) {
                        $scope.setCurrentLanguage(lang);
                    }
                });
            }
        }
    }]);
